import React, { useState } from 'react';
import { useAppDispatch } from '@/store';
import { useThemeContext } from '@/context/ThemeContext';
import Card from '@/components/common/Card';
import Button from '@/components/common/Button';
import logger from '@/services/logger';

interface EditorWindowProps {
  windowId: string;
}

/**
 * Email editor window component
 * Allows editing and previewing of email content
 */
const EditorWindow: React.FC<EditorWindowProps> = ({ windowId }) => {
  const [content, setContent] = useState<string>('');
  const { isDarkMode } = useThemeContext();

  const handleContentChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setContent(event.target.value);
    logger.debug('Editor content updated', { module: 'windows', data: { windowId } });
  };

  const handleSave = () => {
    logger.info('Editor content saved', { 
      module: 'windows', 
      data: { windowId, contentLength: content.length } 
    });
  };

  return (
    <div className="h-full flex flex-col">
      <div className="flex-grow p-2">
        <textarea
          value={content}
          onChange={handleContentChange}
          className="w-full h-full p-3 border rounded-md resize-none bg-white dark:bg-gray-800 text-black dark:text-white"
          placeholder="Enter email content to analyze..."
        />
      </div>
      
      <div className="p-2 border-t flex justify-end">
        <Button 
          variant="primary" 
          size="small"
          onClick={handleSave}
        >
          Save Content
        </Button>
      </div>
    </div>
  );
};

export default EditorWindow; 